import { render, staticRenderFns } from "./MunicipalityPanel.vue?vue&type=template&id=4b2e8e1e"
import script from "./MunicipalityPanel.vue?vue&type=script&lang=js"
export * from "./MunicipalityPanel.vue?vue&type=script&lang=js"
import style0 from "./MunicipalityPanel.vue?vue&type=style&index=0&id=4b2e8e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports